import { VALIDACE_COLOR, validaceIssues } from './receptUtils';

// Třístupňový výkřičník u položky.
//   red    = chybí povinná data
//   orange = revize chybí / starší 6 měsíců
//   green  = jen tip od L(a)M(i)
// Bez stavu nevykreslí nic.
export default function RecipeValidaceBadge({ validace, size = 16 }) {
    const stav = validace?.stav;
    if (!stav) return null;
    const color = VALIDACE_COLOR[stav];
    const issues = validaceIssues(validace);
    const title = issues.join('\n');

    return (
        <span title={title}
            style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: size, height: size, borderRadius: '50%',
                background: color, color: '#fff',
                fontSize: Math.round(size * 0.72), fontWeight: 800, lineHeight: 1,
                flexShrink: 0, boxShadow: `0 0 0 2px ${color}22`,
            }}>
            !
        </span>
    );
}

// Kompaktní kumulace pro hlavičku kategorie: barevné "! N" jen pro nenulové stavy.
export function RecipeValidaceCounts({ counts }) {
    if (!counts) return null;
    const parts = ['red', 'orange', 'green'].filter(k => counts[k] > 0);
    if (parts.length === 0) return null;

    const labelMap = {
        red: 'chybí povinná data',
        orange: 'revize k doplnění',
        green: 'tipy od L(a)M(i)',
    };

    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
            {parts.map(k => (
                <span key={k} title={`${counts[k]} × ${labelMap[k]}`}
                    style={{
                        display: 'inline-flex', alignItems: 'center', gap: 3,
                        padding: '1px 6px 1px 5px', borderRadius: 999,
                        background: `${VALIDACE_COLOR[k]}1F`, color: VALIDACE_COLOR[k],
                        fontSize: 10, fontWeight: 800, lineHeight: 1.4,
                    }}>
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        width: 12, height: 12, borderRadius: '50%',
                        background: VALIDACE_COLOR[k], color: '#fff', fontSize: 9, fontWeight: 800,
                    }}>!</span>
                    {counts[k]}
                </span>
            ))}
        </span>
    );
}
